import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerTermsService,
  ProviderTermsRequestError,
} from '@/services/provider/terms.service';
import type { ProviderTermsSettings, UpdateProviderTermsInput } from '@/types/provider-terms';

export const providerTermsKeys = {
  all: ['provider', 'terms-settings'] as const,
  detail: () => [...providerTermsKeys.all, 'detail'] as const,
  public: () => [...providerTermsKeys.all, 'public'] as const,
};

export function useProviderTermsSettings(enabled = true) {
  return useQuery<ProviderTermsSettings, ProviderTermsRequestError>({
    queryKey: providerTermsKeys.detail(),
    queryFn: () => providerTermsService.getSettings(),
    enabled,
  });
}

export function useUpdateProviderTermsSettings() {
  const queryClient = useQueryClient();

  return useMutation<ProviderTermsSettings, ProviderTermsRequestError, UpdateProviderTermsInput>({
    mutationFn: (input) => providerTermsService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(providerTermsKeys.detail(), settings);
    },
  });
}

export function usePublicProviderTermsUrl(enabled = true) {
  return useQuery<string | null, ProviderTermsRequestError>({
    queryKey: providerTermsKeys.public(),
    queryFn: () => providerTermsService.getPublicTermsUrl(),
    enabled,
    retry: false,
  });
}
